<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 mt-6 text-end pr-3>
       <v-btn @click="isShowingCreateCompanyDialog = true" small class="primary white--text">
        <v-icon small class="mr-2">mdi-plus</v-icon>
        Créer une entreprise
       </v-btn>
      </v-flex>
    </v-layout>
      

    <v-dialog v-model="isShowingCreateCompanyDialog" width="50%" :persistent="isCreateCompanyPending">
      <v-card class="pa-6">
        <v-layout row wrap>
          <v-flex xs12 text-center>
              <h3>Créer une entreprise</h3>
          </v-flex>
        </v-layout>
        <div v-if="isCreateCompanyPending">
          <v-progress-linear indeterminate color="primary" class="mt-3"></v-progress-linear>
        </div>
        <div v-else>
          <v-layout row wrap justify-space-around>
            <v-flex xs12 sm6 mt-8 mb-4>
              <v-text-field label="Nom de l'entreprise" v-model="name" outlined hide-details/>
            </v-flex>
            <v-flex xs12 mt-4 text-center>
              <v-btn @click="createCompany" :disabled="!name" class="secondary white--text">Créer l'entreprise</v-btn>
            </v-flex>
            <v-flex xs12 text-center mt-4>
              <small>Ensuite, tu pourras éditer l'entreprise pour ajouter ses <b>templates</b> et ses <b>noms de domaines</b>.</small>
            </v-flex>
          </v-layout>
        </div>
      </v-card>
    </v-dialog>
  </div>  
</template>

<script>

export default {
  data: () => ({
    isShowingCreateCompanyDialog: false,
    isCreateCompanyPending: false,
    name: "",
  }),
  methods: {
    async createCompany() {
      this.isCreateCompanyPending = true
      const { companyId } = (await this.$functions.httpsCallable('createCompany')({
        name: this.name,
      })).data
      this.$router.push(`/admin?activeTab=listCompanies&companyQuery=${companyId}`)
      this.$router.go()
    }
  }
}
</script>
